import React, { useState, useCallback, useRef } from "react";
import Notice from "./Notice";

let idCounter = 0;

export const useNoticeStack = () => {
  const [notices, setNotices] = useState([]);
  const queueRef = useRef([]);
  const processingRef = useRef(false);

  const processQueue = useCallback(() => {
    if (processingRef.current || queueRef.current.length === 0) return;
    processingRef.current = true;

    const { kind, message, duration } = queueRef.current.shift();
    const id = ++idCounter;
    setNotices((prev) => [...prev, { id, kind, message, duration }]);

    setTimeout(() => {
      setNotices((prev) => prev.filter((n) => n.id !== id));
    }, duration);

    setTimeout(() => {
      processingRef.current = false;
      processQueue();
    }, 300);
  }, []);

  const addNotice = useCallback(
    ({ kind, message, duration = 5000 }) => {
      queueRef.current.push({ kind, message, duration });
      processQueue();
    },
    [processQueue]
  );

  const dismissNotice = useCallback((id) => {
    setNotices((prev) => prev.filter((n) => n.id !== id));
  }, []);

  return { notices, addNotice, dismissNotice };
};

const NoticeStack = ({ notices, dismissNotice, disableClickaway }) => {
  return (
    <div className="notice-stack">
      {notices.map((notice) => (
        <div key={notice.id} className="notice-stack__item">
          <Notice
            details={{ kind: notice.kind, message: notice.message, open: true }}
            autoHideDuration={notice.duration}
            onClose={() => dismissNotice(notice.id)}
            disableClickaway={disableClickaway}
          />
        </div>
      ))}
    </div>
  );
};

export default NoticeStack;
